import React from 'react'
import Link from 'gatsby-link'
import './Header.css'
import logo from './DailyClouds-logo.png'

const Header = () => (
  <div className="Header w-100 d-inline-flex justify-content-between p-2 pl-3 pr-3">
   <div className="d-inline-flex justify-content-center p-1 align-items-center">
     {/* <img className="HeaderLogo" src={logo} /> */}
     <i className="fa fa-newspaper-o icon-logo" />
     <ul className="Header-navbar-menu ml-2">
       <li><Link to='/' className="Header-link">DailyClouds</Link></li>
       <li><Link to='/project' className="Header-link ml-3">project</Link></li>
     </ul>
   </div>
   <a className="inmagik-link" target="_blank" href='https://www.inmagik.com'>by INMAGIK</a>

  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js